import styles from './DotBarChart.module.scss'
import { forwardRef, ForwardedRef, ComponentType } from 'react'
import Circle from './Circle'
import { CircleProps } from '../models'
import { useSprings } from '@react-spring/web'
import {
  CIRCLE_ANIMATION_DELAY,
  CIRCLE_ANIMATION_DELAY_START,
  CIRCLE_ANIMATION_DURATION,
} from '../constants'
import { Color } from '../../../constants'

interface DotBarChartProps {
  width: number
  height: number
  circles: CircleProps[]
  defaultBackgroundColor?: string
  CircleInstance?: ComponentType<CircleProps>
}

const DotBarChart = forwardRef<SVGSVGElement, DotBarChartProps>(
  (
    {
      width,
      height,
      circles,
      CircleInstance = Circle,
      defaultBackgroundColor = Color.Black,
    }: DotBarChartProps,
    ref: ForwardedRef<SVGSVGElement>
  ) => {
    const circleSprings = useSprings(
      circles.length,
      circles.map((circle, index) => ({
        to: { fill: circle.fill, opacity: 1 },
        from: {
          fill: defaultBackgroundColor,
          opacity: 1,
        },
        delay: CIRCLE_ANIMATION_DELAY_START + index * CIRCLE_ANIMATION_DELAY,
        config: { duration: CIRCLE_ANIMATION_DURATION },
      }))
    )

    return (
      <div className={styles.dotBarChart}>
        <svg ref={ref} viewBox={`0 0 ${width} ${height}`}>
          {circleSprings.map((circle, index) => (
            <CircleInstance {...circles[index]} {...circle} key={index} />
          ))}
        </svg>
      </div>
    )
  }
)

export default DotBarChart
